import * as React from 'react';

const SvgEsim = (props) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.3333 30.3327H10.6667C6.08 30.3327 3 27.2527 3 22.666V9.33268C3 4.74602 6.08 1.66602 10.6667 1.66602H17.24C19.2933 1.66602 21.2133 2.46602 22.6667 3.90602L26.76 7.99935C28.2133 9.45268 29 11.3727 29 13.426V22.666C29 27.2527 25.92 30.3327 21.3333 30.3327ZM10.6667 3.66602C7.22667 3.66602 5 5.89268 5 9.33268V22.666C5 26.106 7.22667 28.3327 10.6667 28.3327H21.3333C24.7733 28.3327 27 26.106 27 22.666V13.426C27 11.9193 26.4133 10.4927 25.3333 9.41268L21.24 5.33268C20.1733 4.26602 18.7467 3.66602 17.2267 3.66602H10.6667Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.333496 10.666C0.333496 10.1137 0.781211 9.66602 1.3335 9.66602H4.00016C4.55245 9.66602 5.00016 10.1137 5.00016 10.666C5.00016 11.2183 4.55245 11.666 4.00016 11.666H1.3335C0.781211 11.666 0.333496 11.2183 0.333496 10.666Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.333496 17.332C0.333496 16.7797 0.781211 16.332 1.3335 16.332H4.00016C4.55245 16.332 5.00016 16.7797 5.00016 17.332C5.00016 17.8843 4.55245 18.332 4.00016 18.332H1.3335C0.781211 18.332 0.333496 17.8843 0.333496 17.332Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27 14.666C27 14.1137 27.4477 13.666 28 13.666H30.6667C31.219 13.666 31.6667 14.1137 31.6667 14.666C31.6667 15.2183 31.219 15.666 30.6667 15.666H28C27.4477 15.666 27 15.2183 27 14.666Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27 21.332C27 20.7797 27.4477 20.332 28 20.332H30.6667C31.219 20.332 31.6667 20.7797 31.6667 21.332C31.6667 21.8843 31.219 22.332 30.6667 22.332H28C27.4477 22.332 27 21.8843 27 21.332Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.333496 24C0.333496 23.4477 0.781211 23 1.3335 23H4.00016C4.55245 23 5.00016 23.4477 5.00016 24C5.00016 24.5523 4.55245 25 4.00016 25H1.3335C0.781211 25 0.333496 24.5523 0.333496 24Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.6745 17.38H13.8879V17.8553C13.8879 18.5057 14.116 19.0724 14.5297 19.4765C14.9429 19.8802 15.5197 20.101 16.1805 20.101C16.6622 20.101 17.0842 20.0278 17.4884 19.8528C17.889 19.6792 18.2554 19.4127 18.6363 19.0484C18.7901 18.9114 18.9126 18.8326 19.0298 18.7855C19.1462 18.7388 19.2753 18.7162 19.4521 18.7162C19.7278 18.7162 19.9648 18.7997 20.1272 18.9342C20.2842 19.0643 20.3847 19.2518 20.3847 19.503C20.3847 19.6743 20.3314 19.8547 20.2106 20.0403L20.2044 20.0507C19.6169 21.0384 18.1205 21.7008 16.1527 21.7008C14.5917 21.7008 13.3857 21.2553 12.5713 20.4721C11.7584 19.6903 11.2998 18.5374 11.2998 17.049C11.2998 15.5658 11.7651 14.3853 12.5702 13.5763C13.3751 12.7676 14.5491 12.3008 16.023 12.3008C17.4618 12.3008 18.6302 12.7494 19.4355 13.4825C20.239 14.2139 20.6998 15.2451 20.6998 16.453C20.6998 16.7866 20.6016 17.0047 20.453 17.1422C20.301 17.283 20.0525 17.38 19.6745 17.38ZM13.9353 15.8847L13.9082 16.2096H18.2209L18.2039 15.8935C18.1724 15.3072 17.9467 14.8061 17.5651 14.4518C17.1842 14.0982 16.668 13.9094 16.0878 13.9094C14.9118 13.9094 14.0317 14.7307 13.9353 15.8847Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgEsim;
